module.exports = __webpack_public_path__ + "img/5.314fbd8a.png";